import { useEffect, useState } from "react";
import axios from "axios";
import { Trophy, Users } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MEDALS = ["🥇", "🥈", "🥉"];

export default function ReferralLeaderboard() {
  const { t, dir } = useI18n();
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/referrals/leaderboard?limit=3`)
      .then(r => setItems(r.data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoaded(true));
  }, []);

  if (!loaded || items.length === 0) return null;

  return (
    <div
      data-testid="referral-leaderboard"
      dir={dir}
      className="mt-10 mx-auto max-w-3xl rounded-2xl border border-amber-500/25 bg-gradient-to-br from-amber-500/10 via-emerald-500/5 to-transparent p-5"
    >
      <div className="flex items-center gap-2 mb-4">
        <Trophy className="w-4 h-4 text-amber-300" />
        <div className="text-sm font-bold text-amber-200">
          {t("leaderboard_title") || "Top inviters this month"}
        </div>
        <div className="text-[10px] text-zinc-500 ms-2 inline-flex items-center gap-1">
          <Users className="w-3 h-3" /> {items.reduce((a, b) => a + b.count, 0)} {t("total_invites") || "invites"}
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        {items.map((it, idx) => (
          <div
            key={idx}
            data-testid={`leaderboard-rank-${it.rank}`}
            className={
              "rounded-xl border p-3 flex items-center gap-3 " +
              (it.rank === 1
                ? "border-amber-400/40 bg-amber-500/10"
                : it.rank === 2
                  ? "border-zinc-500/30 bg-zinc-500/5"
                  : "border-orange-500/25 bg-orange-500/5")
            }
          >
            <div className="text-2xl leading-none">{MEDALS[it.rank - 1] || "🏅"}</div>
            {it.picture ? (
              <img src={it.picture} alt="" className="w-9 h-9 rounded-full object-cover" />
            ) : (
              <div className="w-9 h-9 rounded-full bg-zinc-800 flex items-center justify-center text-zinc-300 font-semibold">
                {it.display_name?.[0]?.toUpperCase() || "?"}
              </div>
            )}
            <div className="min-w-0 flex-1">
              <div className="text-sm text-zinc-100 font-semibold truncate">{it.display_name}</div>
              <div className="text-[11px] text-zinc-400">
                {it.count} {t("friends_invited") || "friends invited"}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
